<script lang="ts">
  import type { ComponentProps, Snippet } from "svelte";
  import { dataField } from "../../lib/dataform/dataFormLib.svelte";
  import Fieldset from "./Fieldset.svelte";
  import { partitionNames } from "./util";

  type PropsType = Omit<ComponentProps<typeof Fieldset>, 'children' | 'error'> & {
    name: string;
    required?: boolean;
    horizontal?: boolean;
    vertical?: boolean;
    options: Array<[any, string]>;
    option?: Snippet<[any]>;
  }

  let {
    legend,
    name,
    required = false,
    disabled = undefined,
    horizontal = false,
    vertical = true,
    options,
    option = null,
    class: className,
    postfix = null,
    ...rest
  } : PropsType = $props();

  const field = dataField(name)
  let [inputClass, containerClass] = $derived.by(()=>partitionNames(className, /radio-/))
  let horiz = $derived(horizontal || (vertical === false))
</script>
{#snippet basic(text)}<span>{text}</span>{/snippet}

<Fieldset error={field.error as string} {legend} {disabled} class={containerClass} {postfix} {...rest}>
  <!-- items-start keeps label hit-boxes from having potentially multiple inches of whitespace -->
  <div class="flex gap-4 {horiz ? "flex-row" : "flex-col items-start"}">
    {#each options as [label, value]}
      <label class={["flex flex-row gap-2", horiz ? "items-center" : "items-start"]}>
        <input
          type="radio"
          class="radio {inputClass}"
          class:input-error={!!field.error}
          name={field.name}
          {value}
          bind:group={field.value}
          {required}
        />
        {@render (option || basic)(label)}
      </label>
    {/each}
  </div>
</Fieldset>
